import { Button } from '@one-thd/sui-atomic-components';
import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { productRefinementCountDataModel } from '../models/refinementCountDataModel';

export const ProductRefinementCount = ({
  onDimensionsChange,
  totalProductsCount
}) => {

  const viewProductCountEnabled = useConfigService('fs-prop:viewProductCountEnabled');
  const hasValidCount = totalProductsCount != null;

  return (
    <Button fullWidth onClick={onDimensionsChange}>
      {viewProductCountEnabled && hasValidCount
        ? `View ${totalProductsCount} Result${totalProductsCount === 1 ? '' : 's'}`
        : 'View Results'}
    </Button>
  );
};

ProductRefinementCount.propTypes = {
  onDimensionsChange: PropTypes.func.isRequired,
  totalProductsCount: PropTypes.number
};

ProductRefinementCount.defaultProps = {
  totalProductsCount: 0
};

ProductRefinementCount.dataModel = productRefinementCountDataModel;
